import React, { forwardRef, ReactNode, useRef } from 'react';

import { DIALOGS_PORTAL_ID } from './DialogsPortal';
import classNames from 'classnames';
import * as ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';

export interface ModalPopupProps {
  children?: React.ReactNode;
  className?: string;
  transition?: boolean;
  zIndex?: number;
}

interface WrapperProps {
  children?: ReactNode;
  transition: boolean | undefined;
}

const Wrapper = forwardRef(
  <T extends HTMLElement>(props: WrapperProps, childrenRef: React.Ref<T>): React.ReactElement | null => {
    const dialogElement = document.getElementById(DIALOGS_PORTAL_ID);

    if (!dialogElement) {
      return null;
    }

    return props.transition === false
      ? ReactDOM.createPortal(<React.Fragment>{props.children}</React.Fragment>, dialogElement)
      : ReactDOM.createPortal(
          <CSSTransition nodeRef={childrenRef} classNames="fade" timeout={700} appear={true} in={true}>
            {props.children}
          </CSSTransition>,
          dialogElement
        );
  }
);

export const ModalPopup = forwardRef((props: ModalPopupProps, ref: React.Ref<HTMLDivElement>): React.ReactElement => {
  const childrenRef = useRef(null);
  const preferredRef = ref ?? childrenRef;

  return (
    <Wrapper transition={props.transition} ref={preferredRef}>
      <div
        ref={preferredRef}
        className={classNames('modal-popup', props.className ? props.className : '')}
        style={{ zIndex: props.zIndex }}
      >
        {props.children}
      </div>
    </Wrapper>
  );
});
